// extracted by mini-css-extract-plugin
export default {"mediaDataTable":"mediaDataTable_mediaDataTable__jE9XE","mediaDataIndex":"mediaDataTable_mediaDataIndex__WybWL"};